import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'
import { type ApiQueryResult } from '~/utils/types'

export const useUsersQuery = (): ApiQueryResult =>
  useQuery({
    queryKey: ['users', 'active'],
    queryFn: async () => {
      const { data } = await adminApi.getUsers()
      return data.data
    }
  })

export const useDisabledUsersQuery = (): ApiQueryResult =>
  useQuery({
    queryKey: ['users', 'disabled'],
    queryFn: async () => {
      const { data } = await adminApi.getDisabledUsers()
      return data.data
    }
  })
